/**
 * Chart palette.
 *
 * Brand chrome is red (primary) + Anietronic dark blue (secondary) on
 * a black / grey / white base. Data-vis charts need distinguishable
 * hues, so the line/bar palette leads with brand red and pairs it
 * with the Anietronic blue accent plus complementary warm/cool tones
 * that read well on dark surfaces.
 *
 * Status colors retain conventional semantics so operators can scan
 * the donut without translation: green = online, red = offline,
 * amber = pending, cyan = informational.
 */

export const chartColors = {
  red: "#e11d2e",
  redDeep: "#991b1b",
  blue: "#2c5aa8",
  blueLight: "#c9daf8",
  amber: "#f59e0b",
  cyan: "#38bdf8",
  emerald: "#22c55e",
  purple: "#a855f7",
  slate: "#9ca3af",
} as const;

export const lineSeriesPalette = [
  chartColors.red,
  chartColors.blue,
  chartColors.amber,
  chartColors.cyan,
] as const;

export const triPhasePalette = {
  l12: chartColors.red,
  l23: chartColors.blue,
  l31: chartColors.amber,
} as const;

export const powerPalette = {
  active: chartColors.red,
  reactive: chartColors.blue,
  apparent: chartColors.amber,
} as const;

export const statusColors: Record<string, string> = {
  online: chartColors.emerald,
  offline: chartColors.red,
  provisioned: chartColors.blue,
  pending: chartColors.amber,
  applied: chartColors.emerald,
  rejected: chartColors.red,
  failed: chartColors.red,
  unknown: chartColors.slate,
};
